<template>
  <v-container fluid>
    <!-- Header -->
    <div class="dashboard-header">
      <h1 class="dashboard-title">สถิตินักเรียน/นักศึกษา ตามภาค</h1>
      <p class="dashboard-subtitle">สำนักงานคณะกรรมการการอาชีพวศึกษา (สอศ.)</p>
    </div>

    <!-- Filter Section -->
    <div class="filter-section">
      <div class="filter-container">
        <div class="filter-group">
          <label class="filter-label">ปีการศึกษา</label>
          <select
            v-model="filters.rate_work_college_year"
            class="filter-input"
            @change="handleFilterChange"
          >
            <option value="">-- ทั้งหมด --</option>
            <option v-for="year in uniqueYears" :key="year" :value="year">
              {{ year }}
            </option>
          </select>
        </div>

        <div class="filter-group">
          <label class="filter-label">ภาค</label>
          <select
            v-model="filters.region_name"
            class="filter-input"
            @change="handleFilterChange"
          >
            <option value="">-- ทั้งหมด --</option>
            <option v-for="region in uniqueRegions" :key="region" :value="region">
              {{ region }}
            </option>
          </select>
        </div>

        <div class="filter-group">
          <label class="filter-label">ชั้นปี</label>
          <select
            v-model="filters.rate_work_college_class"
            class="filter-input"
            @change="handleFilterChange"
          >
            <option value="">-- ทั้งหมด --</option>
            <option
              v-for="classItem in uniqueClasses"
              :key="classItem"
              :value="classItem"
            >
              {{ classItem }}
            </option>
          </select>
        </div>

        <div class="filter-actions">
          <button class="btn-filter-reset" @click="resetFilters">
            🔄 รีเซ็ต
          </button>
          <button class="btn-export-excel" @click="exportToExcel">
            📊 ส่งออก Excel
          </button>
        </div>
      </div>
    </div>


    <!-- Charts Section -->
    <div class="charts-container">
      <!-- Chart by Region -->
      <div class="chart-box">
        <div class="chart-header">
          <div class="chart-title">📍 สถิติตามภาค</div>
        </div>
        <div v-if="!isLoadingChart" class="chart-wrapper">
          <div v-if="hasRegionData" class="chart-inner">
            <apexchart
              v-if="chartByRegionSeries && chartByRegionSeries.length > 0"
              type="bar"
              :options="chartByRegionOptions"
              :series="chartByRegionSeries"
              height="380"
            />
          </div>
          <div v-else class="empty-chart">
            ไม่มีข้อมูล กรุณาตรวจสอบการเชื่อมต่อ API
          </div>
        </div>
        <div v-else class="loading-skeleton">
          <div class="skeleton-bar"></div>
        </div>
      </div>

      <!-- Chart by Year and Region -->
      <div class="chart-box">
        <div class="chart-header">
          <div class="chart-title">📊 สถิติตามปีและภาค</div>
        </div>
        <div v-if="!isLoadingChart" class="chart-wrapper">
          <div v-if="hasYearRegionData" class="chart-inner">
            <apexchart
              v-if="chartByYearRegionSeries && chartByYearRegionSeries.length > 0"
              type="bar"
              :options="chartByYearRegionOptions"
              :series="chartByYearRegionSeries"
              height="380"
            />
          </div>
          <div v-else class="empty-chart">
            ไม่มีข้อมูล กรุณาตรวจสอบการเชื่อมต่อ API
          </div>
        </div>
        <div v-else class="loading-skeleton">
          <div class="skeleton-bar"></div>
        </div>
      </div>
    </div>

    <!-- Second Row Charts -->
    <div class="charts-container">
      <!-- Chart by Year -->
      <div class="chart-box">
        <div class="chart-header">
          <div class="chart-title">📅 สถิติตามปีการศึกษา</div>
        </div>
        <div v-if="!isLoadingChart" class="chart-wrapper">
          <div v-if="hasYearData" class="chart-inner">
            <apexchart
              v-if="chartByYearSeries && chartByYearSeries.length > 0"
              type="line"
              :options="chartByYearOptions"
              :series="chartByYearSeries"
              height="380"
            />
          </div>
          <div v-else class="empty-chart">
            ไม่มีข้อมูล กรุณาตรวจสอบการเชื่อมต่อ API
          </div>
        </div>
        <div v-else class="loading-skeleton">
          <div class="skeleton-bar"></div>
        </div>
      </div>

      <!-- Chart by Class -->
      <div class="chart-box">
        <div class="chart-header">
          <div class="chart-title">🎓 สถิติตามชั้นปี</div>
        </div>
        <div v-if="!isLoadingChart" class="chart-wrapper">
          <div v-if="hasClassData" class="chart-inner">
            <apexchart
              v-if="chartByClassSeries && chartByClassSeries.length > 0"
              type="donut"
              :options="chartByClassOptions"
              :series="chartByClassSeries"
              height="380"
            />
          </div>
          <div v-else class="empty-chart">
            ไม่มีข้อมูล กรุณาตรวจสอบการเชื่อมต่อ API
          </div>
        </div>
        <div v-else class="loading-skeleton">
          <div class="skeleton-bar"></div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import * as XLSX from "xlsx";

export default {
  name: "vw_student_overall_count_region",
  data() {
    return {
      ApiKey: "HRvec2021",
      rawData: [],
      filteredData: [],
      isLoadingChart: true,
      filters: {
        rate_work_college_year: "",
        region_name: "",
        rate_work_college_class: ""
      }
    };
  },
  computed: {
    uniqueYears() {
      return [
        ...new Set(this.rawData.map(item => item.rate_work_college_year))
      ].sort((a, b) => b - a);
    },
    uniqueRegions() {
      return [
        ...new Set(this.rawData.map(item => item.region_name))
      ].sort();
    },
    uniqueClasses() {
      return [
        ...new Set(this.rawData.map(item => item.rate_work_college_class))
      ].sort();
    },
    totalStudents() {
      return this.filteredData.reduce(
        (sum, item) => sum + parseInt(item.countstd || 0),
        0
      );
    },
    groupedByRegion() {
      const grouped = {};
      this.filteredData.forEach(item => {
        const region = item.region_name;
        if (!grouped[region]) {
          grouped[region] = 0;
        }
        grouped[region] += parseInt(item.countstd || 0);
      });
      return grouped;
    },
    groupedByYear() {
      const grouped = {};
      this.filteredData.forEach(item => {
        const year = item.rate_work_college_year;
        if (!grouped[year]) {
          grouped[year] = 0;
        }
        grouped[year] += parseInt(item.countstd || 0);
      });
      return grouped;
    },
    groupedByClass() {
      const grouped = {};
      this.filteredData.forEach(item => {
        const classItem = item.rate_work_college_class;
        if (!grouped[classItem]) {
          grouped[classItem] = 0;
        }
        grouped[classItem] += parseInt(item.countstd || 0);
      });
      return grouped;
    },
    groupedByYearAndRegion() {
      const grouped = {};
      this.filteredData.forEach(item => {
        const key = `${item.rate_work_college_year}`;
        if (!grouped[key]) {
          grouped[key] = {};
        }
        if (!grouped[key][item.region_name]) {
          grouped[key][item.region_name] = 0;
        }
        grouped[key][item.region_name] += parseInt(item.countstd || 0);
      });
      return grouped;
    },
    hasRegionData() {
      return Object.keys(this.groupedByRegion).length > 0;
    },
    hasYearData() {
      return Object.keys(this.groupedByYear).length > 0;
    },
    hasClassData() {
      return Object.keys(this.groupedByClass).length > 0;
    },
    hasYearRegionData() {
      return Object.keys(this.groupedByYearAndRegion).length > 0;
    },
    chartByRegionSeries() {
      try {
        const regionLabels = Object.keys(this.groupedByRegion).sort();
        const regionData = regionLabels.map(region => this.groupedByRegion[region]);

        if (regionData.length === 0) return [];

        return [
          {
            name: "จำนวนนักเรียน/นักศึกษา",
            data: regionData
          }
        ];
      } catch (error) {
        console.error("Error in chartByRegionSeries:", error);
        return [];
      }
    },
    chartByRegionOptions() {
      const regionLabels = Object.keys(this.groupedByRegion).sort();

      return {
        chart: {
          type: "column",
          fontFamily: "'Roboto', sans-serif",
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true
            }
          },
          animations: {
            enabled: true,
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150
            }
          }
        },
        colors: ["#3B82F6"],
        plotOptions: {
          bar: {
            columnWidth: "70%",
            borderRadius: 4,
            dataLabels: {
              position: "top"
            }
          }
        },
        dataLabels: {
          enabled: true,
          offsetY: -20,
          style: {
            fontSize: "12px",
            colors: ["#3B82F6"],
            fontWeight: 600
          },
          formatter: val => this.formatNumberShort(val)
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["#ffffff"]
        },
        grid: {
          borderColor: "#e5e7eb",
          strokeDashArray: 3,
          padding: {
            top: 20,
            right: 10,
            bottom: 0,
            left: 10
          }
        },
        tooltip: {
          theme: "light",
          y: {
            formatter: val => `${this.formatNumber(val)} คน`
          }
        },
        xaxis: {
          categories: regionLabels,
          labels: {
            style: {
              fontSize: "12px",
              fontFamily: "'Roboto', sans-serif"
            }
          }
        },
        yaxis: {
          title: {
            text: "จำนวน (คน)",
            style: {
              fontSize: "12px",
              fontWeight: 600
            }
          },
          labels: {
            formatter: val => this.formatNumberShort(val),
            style: {
              fontSize: "11px"
            }
          }
        }
      };
    },
    chartByYearSeries() {
      try {
        const yearLabels = Object.keys(this.groupedByYear).sort();
        const yearData = yearLabels.map(year => this.groupedByYear[year]);

        if (yearData.length === 0) return [];

        return [
          {
            name: "จำนวนนักเรียน/นักศึกษา",
            data: yearData
          }
        ];
      } catch (error) {
        console.error("Error in chartByYearSeries:", error);
        return [];
      }
    },
    chartByYearOptions() {
      const yearLabels = Object.keys(this.groupedByYear).sort();

      return {
        chart: {
          type: "line",
          fontFamily: "'Roboto', sans-serif",
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true
            }
          },
          animations: {
            enabled: true,
            speed: 800
          }
        },
        colors: ["#10B981"],
        stroke: {
          curve: "smooth",
          width: 3
        },
        grid: {
          borderColor: "#e5e7eb",
          strokeDashArray: 3,
          padding: {
            top: 10,
            right: 10,
            bottom: 0,
            left: 10
          }
        },
        markers: {
          size: 5,
          colors: ["#10B981"],
          strokeColors: "#ffffff",
          strokeWidth: 2,
          hover: {
            size: 7
          }
        },
        dataLabels: {
          enabled: false
        },
        tooltip: {
          theme: "light",
          y: {
            formatter: val => `${this.formatNumber(val)} คน`
          }
        },
        xaxis: {
          categories: yearLabels,
          labels: {
            style: {
              fontSize: "12px",
              fontFamily: "'Roboto', sans-serif"
            }
          }
        },
        yaxis: {
          title: {
            text: "จำนวน (คน)",
            style: {
              fontSize: "12px",
              fontWeight: 600
            }
          },
          labels: {
            formatter: val => this.formatNumberShort(val),
            style: {
              fontSize: "11px"
            }
          }
        }
      };
    },
    chartByClassSeries() {
      try {
        const classLabels = Object.keys(this.groupedByClass).sort();
        return classLabels.map(cls => this.groupedByClass[cls]);
      } catch (error) {
        console.error("Error in chartByClassSeries:", error);
        return [];
      }
    },
    chartByClassOptions() {
      const classLabels = Object.keys(this.groupedByClass).sort();

      return {
        chart: {
          type: "donut",
          fontFamily: "'Roboto', sans-serif",
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true
            }
          },
          animations: {
            enabled: true,
            speed: 800
          }
        },
        colors: ["#F59E0B", "#EF4444", "#8B5CF6", "#EC4899", "#14B8A6"],
        plotOptions: {
          pie: {
            donut: {
              size: "65%",
              labels: {
                show: true,
                name: {
                  fontSize: "12px"
                },
                value: {
                  fontSize: "16px",
                  fontWeight: 600,
                  formatter: val => this.formatNumberShort(val)
                },
                total: {
                  show: true,
                  fontSize: "13px",
                  fontWeight: 600,
                  label: "รวม",
                  formatter: val => this.formatNumber(val)
                }
              }
            }
          }
        },
        labels: classLabels,
        legend: {
          position: "bottom",
          fontSize: "12px",
          fontFamily: "'Roboto', sans-serif"
        },
        tooltip: {
          theme: "light",
          y: {
            formatter: val => `${this.formatNumber(val)} คน`
          }
        },
        dataLabels: {
          enabled: true,
          formatter: val => `${val.toFixed(1)}%`,
          style: {
            fontSize: "12px",
            fontWeight: 600
          }
        }
      };
    },
    chartByYearRegionSeries() {
      try {
        const yearLabels = Object.keys(this.groupedByYearAndRegion).sort();
        const allRegions = [...new Set(
          Object.values(this.groupedByYearAndRegion).flatMap(y => Object.keys(y))
        )].sort();

        return allRegions.map(region => ({
          name: region,
          data: yearLabels.map(year => 
            this.groupedByYearAndRegion[year][region] || 0
          )
        }));
      } catch (error) {
        console.error("Error in chartByYearRegionSeries:", error);
        return [];
      }
    },
    chartByYearRegionOptions() {
      const yearLabels = Object.keys(this.groupedByYearAndRegion).sort();

      return {
        chart: {
          type: "bar",
          fontFamily: "'Roboto', sans-serif",
          stacked: false,
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true
            }
          },
          animations: {
            enabled: true,
            speed: 800
          }
        },
        colors: ["#3B82F6", "#10B981", "#F59E0B", "#EF4444", "#8B5CF6", "#EC4899"],
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "65%",
            borderRadius: 4
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["#ffffff"]
        },
        grid: {
          borderColor: "#e5e7eb",
          strokeDashArray: 3,
          padding: {
            top: 10,
            right: 10,
            bottom: 0,
            left: 10
          }
        },
        tooltip: {
          theme: "light",
          y: {
            formatter: val => `${this.formatNumber(val)} คน`
          }
        },
        xaxis: {
          categories: yearLabels,
          labels: {
            style: {
              fontSize: "12px",
              fontFamily: "'Roboto', sans-serif"
            }
          }
        },
        yaxis: {
          title: {
            text: "จำนวน (คน)",
            style: {
              fontSize: "12px",
              fontWeight: 600
            }
          },
          labels: {
            formatter: val => this.formatNumberShort(val),
            style: {
              fontSize: "11px"
            }
          }
        },
        legend: {
          position: "top",
          fontSize: "12px",
          fontFamily: "'Roboto', sans-serif"
        }
      };
    }
  },
  watch: {
    filteredData: {
      handler() {
        this.$forceUpdate();
      },
      deep: true
    }
  },
  async mounted() {
    await this.fetchStudentData();
  },
  methods: {
    formatNumber(num) {
      if (!num) return "0";
      return parseInt(num).toLocaleString("th-TH");
    },
    formatNumberShort(num) {
      if (!num) return "0";
      const n = parseInt(num);
      if (n >= 1000000) {
        return (n / 1000000).toFixed(1) + "M";
      } else if (n >= 1000) {
        return (n / 1000).toFixed(1) + "K";
      }
      return n.toLocaleString("th-TH");
    },
    async fetchStudentData() {
      try {
        this.isLoadingChart = true;

        if (!this.$http) {
          console.error("HTTP client not configured");
          this.isLoadingChart = false;
          return;
        }

        const response = await this.$http.post(
          "vw_student_overall_count_region.php",
          {
            ApiKey: this.ApiKey
          }
        );

        if (response.data && response.data.status) {
          this.rawData = response.data.data || [];
          this.applyFilters();
        } else {
          console.error("API error:", response.data);
        }

        this.isLoadingChart = false;
      } catch (error) {
        console.error("Error fetching student data:", error);
        this.isLoadingChart = false;
      }
    },
    applyFilters() {
      this.filteredData = this.rawData.filter(item => {
        const yearMatch =
          !this.filters.rate_work_college_year ||
          item.rate_work_college_year === this.filters.rate_work_college_year;
        const regionMatch =
          !this.filters.region_name ||
          item.region_name === this.filters.region_name;
        const classMatch =
          !this.filters.rate_work_college_class ||
          item.rate_work_college_class === this.filters.rate_work_college_class;
        return yearMatch && regionMatch && classMatch;
      });
    },
    handleFilterChange() {
      this.applyFilters();
    },
    resetFilters() {
      this.filters.rate_work_college_year = "";
      this.filters.region_name = "";
      this.filters.rate_work_college_class = "";
      this.applyFilters();
    },
    exportToExcel() {
      try {
        // Prepare data
        const exportData = this.filteredData.map((item, index) => ({
          "ลำดับ": index + 1,
          "ปีการศึกษา": item.rate_work_college_year,
          "ภาค": item.region_name,
          "ชั้นปี": item.rate_work_college_class,
          "จำนวนนักเรียน/นักศึกษา": parseInt(item.countstd || 0)
        }));

        // Create workbook
        const ws = XLSX.utils.json_to_sheet(exportData, {
          header: ["ลำดับ", "ปีการศึกษา", "ภาค", "ชั้นปี", "จำนวนนักเรียน/นักศึกษา"]
        });

        // Set column widths
        const wscols = [
          { wch: 8 },
          { wch: 15 },
          { wch: 15 },
          { wch: 15 },
          { wch: 25 }
        ];
        ws["!cols"] = wscols;

        // Add summary sheet
        const summaryData = [
          { "รายงาน": "สรุปข้อมูลสถิตินักเรียน/นักศึกษาตามภาค" },
          { "รายงาน": "" },
          { "รายงาน": "สรุปข้อมูล" },
          { "รายงาน": "ค่า" },
          { "รายงาน": "รวมนักเรียน/นักศึกษา", "ค่า": this.totalStudents },
          { "รายงาน": "จำนวนปีการศึกษา", "ค่า": this.uniqueYears.length },
          { "รายงาน": "จำนวนภาค", "ค่า": this.uniqueRegions.length },
          { "รายงาน": "จำนวนชั้นปี", "ค่า": this.uniqueClasses.length }
        ];

        const wsSummary = XLSX.utils.json_to_sheet(summaryData, {
          header: ["รายงาน", "ค่า"]
        });
        wsSummary["!cols"] = [{ wch: 25 }, { wch: 20 }];

        // Create workbook with multiple sheets
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, wsSummary, "สรุป");
        XLSX.utils.book_append_sheet(wb, ws, "รายละเอียด");

        // Generate filename with date
        const now = new Date();
        const dateStr = now.toISOString().slice(0, 10);
        const filename = `สถิตินักเรียนตามภาค_${dateStr}.xlsx`;

        // Save file
        XLSX.writeFile(wb, filename);

        // Show success message
        alert("ส่งออกข้อมูล Excel สำเร็จ!");
      } catch (error) {
        console.error("Error exporting to Excel:", error);
        alert("เกิดข้อผิดพลาดในการส่งออกข้อมูล");
      }
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.student-regional-dashboard {
  padding: 24px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
  font-family: "Roboto", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}
.dashboard-header {
  margin-bottom: 32px;
  text-align: center;
}

.dashboard-title {
  font-size: 28px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 8px;
}

.dashboard-subtitle {
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
}
/* Header */
.dashboard-header {
  margin-bottom: 32px;
  text-align: center;
}

.dashboard-title {
  font-size: 28px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 8px;
}

.dashboard-subtitle {
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
}

/* Filter Section */
.filter-section {
  background: white;
  padding: 24px;
  border-radius: 12px;
  margin-bottom: 28px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.05);
}

.filter-container {
  display: flex;
  gap: 16px;
  align-items: flex-end;
  flex-wrap: wrap;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 180px;
  flex: 1;
  min-width: 150px;
}

.filter-label {
  font-size: 12px;
  font-weight: 700;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

.filter-input {
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  background: white;
  color: #1f2937;
  transition: all 0.2s ease;
  cursor: pointer;
  font-family: inherit;
}

.filter-input:hover {
  border-color: #9ca3af;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.filter-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.filter-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}

.btn-filter-reset,
.btn-export-excel {
  padding: 10px 18px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  font-family: inherit;
}

.btn-filter-reset {
  background: #6b7280;
  color: white;
}

.btn-filter-reset:hover {
  background: #4b5563;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.btn-export-excel {
  background: #10b981;
  color: white;
}

.btn-export-excel:hover {
  background: #059669;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Statistics Cards */
.stats-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 5px;
  margin-bottom: 28px;
}

.stat-card {
  background: white;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  gap: 16px;
  transition: all 0.3s ease;
  border-left: 4px solid #3b82f6;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12);
}

.stat-card.stat-total {
  border-left-color: #3b82f6;
}

.stat-card.stat-years {
  border-left-color: #10b981;
}

.stat-card.stat-regions {
  border-left-color: #f59e0b;
}

.stat-card.stat-classes {
  border-left-color: #8b5cf6;
}

.stat-icon {
  font-size: 32px;
  min-width: 50px;
  text-align: center;
}

.stat-content {
  flex: 1;
}

.stat-label {
  font-size: 12px;
  color: #6b7280;
  font-weight: 600;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stat-value {
  font-size: 28px;
  font-weight: 700;
  color: #1f2937;
}

/* Charts Container */
.charts-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
  gap: 24px;
  margin-bottom: 28px;
}

.chart-box {
  background: white;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.05);
  min-height: 480px;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
}

.chart-box:hover {
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12);
}

.chart-header {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 2px solid #e5e7eb;
  padding-bottom: 12px;
}

.chart-title {
  font-size: 16px;
  font-weight: 700;
  color: #1f2937;
}

.chart-wrapper {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 380px;
}

.chart-inner {
  width: 100%;
}

.empty-chart {
  width: 100%;
  height: 380px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
  font-size: 14px;
  background: #f9fafb;
  border-radius: 6px;
}

.loading-skeleton {
  width: 100%;
  height: 380px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9fafb;
  border-radius: 6px;
}

.skeleton-bar {
  width: 80%;
  height: 20px;
  background: linear-gradient(
    90deg,
    #e5e7eb 25%,
    #f3f4f6 50%,
    #e5e7eb 75%
  );
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* Table Section */
.table-section {
  background: white;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e5e7eb;
}

.table-title {
  font-size: 18px;
  font-weight: 700;
  color: #1f2937;
}

.table-info {
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;
}

.table-responsive {
  overflow-x: auto;
}

.detail-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.detail-table thead {
  background: linear-gradient(180deg, #f3f4f6 0%, #e5e7eb 100%);
}

.detail-table thead th {
  padding: 14px 12px;
  text-align: left;
  font-weight: 700;
  color: #374151;
  border-bottom: 2px solid #d1d5db;
  position: sticky;
  top: 0;
}

.detail-table thead th.col-num {
  width: 8%;
  text-align: center;
}

.detail-table thead th.col-year {
  width: 15%;
}

.detail-table thead th.col-region {
  width: 15%;
}

.detail-table thead th.col-class {
  width: 15%;
}

.detail-table thead th.col-count {
  width: 25%;
  text-align: right;
}

.detail-table tbody td {
  padding: 14px 12px;
  border-bottom: 1px solid #e5e7eb;
  color: #1f2937;
  transition: all 0.2s ease;
}

.detail-table tbody td.col-num {
  text-align: center;
  color: #9ca3af;
}

.detail-table tbody td.col-count {
  text-align: right;
  font-weight: 600;
  color: #3b82f6;
}

.detail-table tbody .row-data:hover {
  background: #f9fafb;
}

.detail-table tbody .row-empty td {
  text-align: center;
  color: #9ca3af;
  font-style: italic;
  padding: 24px 12px;
}

.text-center {
  text-align: center;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .charts-container {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .student-regional-dashboard {
    padding: 16px;
  }

  .dashboard-title {
    font-size: 24px;
  }

  .filter-section {
    padding: 16px;
  }

  .filter-container {
    flex-direction: column;
  }

  .filter-group {
    width: 100%;
    min-width: auto;
  }

  .filter-actions {
    width: 100%;
    flex-direction: column;
  }

  .btn-filter-reset,
  .btn-export-excel {
    width: 100%;
  }

  .stats-cards {
    grid-template-columns: 1fr;
  }

  .stat-card {
    flex-direction: column;
    text-align: center;
    align-items: center;
  }

  .stat-icon {
    font-size: 28px;
  }

  .stat-value {
    font-size: 24px;
  }

  .charts-container {
    gap: 16px;
  }

  .chart-box {
    min-height: 350px;
  }

  .chart-wrapper {
    min-height: 300px;
  }

  .empty-chart {
    height: 300px;
  }

  .loading-skeleton {
    height: 300px;
  }

  .detail-table {
    font-size: 12px;
  }

  .detail-table thead th,
  .detail-table tbody td {
    padding: 8px;
  }

  .table-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
}

@media (max-width: 480px) {
  .student-regional-dashboard {
    padding: 12px;
  }

  .dashboard-title {
    font-size: 20px;
  }

  .stats-cards {
    grid-template-columns: 1fr;
  }

  .stat-value {
    font-size: 20px;
  }

  .table-responsive {
    font-size: 11px;
  }

  .detail-table thead th,
  .detail-table tbody td {
    padding: 6px 4px;
  }
}
</style>